import { GalleryProps } from 'ech-components/src/components/Gallery';
import { ImageInterface } from 'ech-components/src/types';

const galleryService = (data: {
  title: string;
  items: Array<ImageInterface | { youtubeVideoId: string }>;
  showImageCaptions?: boolean;
}): GalleryProps => {
  const imageSizes = {
    0: [430, 430],
    480: [720, 720],
    768: [470, 470],
    1024: [380, 380],
    1280: [400, 400],
    1440: [400, 400],
  };

  return {
    title: data?.title,
    items:
      data?.items.map((item) => {
        if ('image' in item) {
          item.imageSizes = imageSizes;
          item.caption = data.showImageCaptions ? item.caption : undefined;
        }

        return item;
      }) ?? [],
  };
};

export default galleryService;
